import InstitionList from "../../../components/admin/institution/InstitutionList";
import Admin from "../../Admin";

const Institution = () => {
    return ( 
        <Admin>
            <InstitionList/>
        </Admin>
     );
}
 
export default Institution;